import { createReducer } from 'redux-act';
import {requestUserSignup, responseUserSignup} from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestUserSignup]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

  [responseUserSignup]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
